import _RentalTripsService from "../services/rental-trip-service";
import { IRentalTripGuestService } from "../types/services/rental-trip-guest-service";
import { IRentalTripService } from "../types/services/rental-trip-service";

const instance = new _RentalTripsService();

export const RentalTripService: IRentalTripService = instance;

export const RentalTripGuestService: IRentalTripGuestService = instance;
